import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa"; // Using react-icons instead of FontAwesome
import logo from "../../assets/logo.svg";
import "./header.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <header className="header">
      <div className="header-container">
        <a href="/" className="logo-link">
          <img src={logo} alt="Logo" className="logo" />
          <span className="website-name">Thought Box</span>
        </a>
        <nav
          className={`nav ${isMenuOpen ? "nav--open" : ""}`}
          aria-label="Main navigation"
        >
          <ul className="nav-list">
            <li className="nav-item">
              <a href="/" className="nav-link">
                Home
              </a>
            </li>
            <li className="nav-item">
              <a href="/blogs" className="nav-link">
                Blogs
              </a>
            </li>
            <li className="nav-item">
              <a href="/conversations" className="nav-link">
                Dialogues
              </a>
            </li>
            <li className="nav-item">
              <a href="/about" className="nav-link">
                About
              </a>
            </li>
          </ul>
        </nav>
        <button
          className="menu-btn"
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
          aria-expanded={isMenuOpen}
        >
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>
    </header>
  );
};

export default Header;
